<template>
  <el-row>
    <el-col :span="24">
      <!-- 页头 -->
      <el-row class="header" v-if="this.$route.path == '/main/home'">
        <img class="left-icon" src="~@/assets/header-icon.png" alt="">
        <p class="title">基于大数据智能的多层次知识检索平台</p>
        <div class="right-icon-wrapper">
          <img class="right-icon" src="~@/assets/header-icon2.png" alt="">
        </div>
      </el-row>
      <!-- 导航 -->
      <el-row class="top_nav">
        <p class="smallTitle" v-if="this.$route.path != '/main/home'">基于大数据智能的多层次知识检索平台</p>
        <el-menu :default-active="$route.path"
        mode="horizontal"
        background-color="#1287C9"
        text-color="#fff"
        active-text-color="#2DF2FF"
        class = "nav"
        router>
          <el-menu-item index="/main/home" id="nav-home">首 页</el-menu-item>
        </el-menu>
        <div class="personal_center">
          <span class="login" v-if="!user.username" @click="loginDialogVisible = true">
            <i class="el-icon-s-custom"/>登录
          </span>
          <el-dropdown placement="bottom" v-else>
            <span class="user-name">
              <i class="el-icon-s-custom"/>{{user.username}}<i class="el-icon-arrow-left el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown" class="p_c_dropdown_menu">
              <el-dropdown-item icon="el-icon-postcard" @click.native="gotoAccount()">账号信息</el-dropdown-item>
              <el-dropdown-item icon="el-icon-time" @click.native="gotoHistory()">我的历史</el-dropdown-item>
              <el-dropdown-item icon="el-icon-star-off" @click.native="gotoCollection()">我的收藏</el-dropdown-item>
              <el-dropdown-item icon="el-icon-right" @click.native="exit()">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-row>
      <!-- 路由 -->
      <el-row>
        <el-col :span="24">
          <div><router-view v-if="isRouterAlive"/></div>
          <el-row class="footer">
            <img src="~@/assets/footer-icon.png" alt="" >
            <span>中知深德知识产权运营管理（深圳）有限公司</span>
          </el-row>
        </el-col>
      </el-row>
    </el-col>
    <el-dialog title="平台登录" center :visible.sync="loginDialogVisible" width="400px">
      <p>
        <el-input v-model="account" placeholder="请输入账户"></el-input>
      </p>
      <p>
        <el-input type="password" v-model="password" placeholder="请输入密码"></el-input>
      </p>
      <div class="login-footer">
        <el-button @click="loginDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="login()">登 录</el-button>
      </div>
    </el-dialog>
  </el-row>
  
</template>

<script>
  export default {
    name: 'index',
    data() {
      return {
        account:'zltest123',
        password:123456,
        user:{},
        loginDialogVisible:false,
        height:'',
        isRouterAlive:true
      }
    },
    //created() {},
    mounted() {
      let user=sessionStorage.getItem('user');
      if(user){
        this.user=JSON.parse(user)
      }else{
        this.login()
      }
    },
    methods: {
      login(){
        // if(!this.account){
        //   this.$message.error('请输入账户');
        //   return;
        // }
        // if(!this.password){
        //   this.$message.error('请输入密码');
        //   return;
        // }
        this.user={
          username: "manager1",
          email: "564785000@gmail.com",
          company_name: "",
          search_time: "26/50000",
          download_time: "4/50000",
          expiration_date: "2027-12-08"
        };
        sessionStorage.setItem('user',JSON.stringify(this.user));
        // this.$message.success('登录成功');
        this.loginDialogVisible=false;
        this.isRouterAlive=false;
        this.$nextTick(function(){
          this.isRouterAlive=true
        })
      },
      gotoAccount() {
        this.$router.push('/personal_center/account');
      },
      gotoHistory() {
        this.$router.push('/personal_center/history');
      },
      gotoCollection() {
        this.$router.push('/personal_center/collection');
      },
      exit() {
        let that=this;
        this.$confirm('确认退出登录？')
          .then(()=> {
            that.user={};
            sessionStorage.clear();
            if(that.$route.path!='/main/home'){
              that.$router.push('/main/home');
            }else{
              that.loginDialogVisible=false;
              that.isRouterAlive=false;
              that.$nextTick(function(){
                that.isRouterAlive=true
              })
            }
            that.$message.success('退出登录成功');
          })
      }
    }
  }
</script>

<style>
  .top_nav {
    height: 48px;
    background-color: #1287C9;
    border-bottom: 1px solid #5795B8;
    display: flex;
  }
  .login{
    color:#fff;
    height: 47px;
    line-height: 47px;
    cursor: pointer;
  }
  .nav {
    padding-left: 1.6%;
    border-bottom: 1px solid #5795B8 !important;
    height: 47px !important;
  }
  .el-menu--popup {
    border-radius: 4px;
    min-width: 126px;
    padding-top: 5px;
    padding-bottom: 5px;
  }
  .el-menu-item, .el-submenu__title {
    padding: 0px 32px 0px 32px;
    font-size: 16px;
    text-align: center;
    height: 47px !important;
    line-height: 47px !important;
  }
  .el-menu-item:active {
    color: #2DF2FF !important;
  }
  #nav-home {
    margin-right: 16px !important;
  }
  .nav-subitem {
    height: 40px !important;
    line-height: 40px !important;
    padding-left: 10px !important;
  }
  .el-submenu__icon-arrow {
    color: #FFFFFF !important;
  }
  .el-submenu.is-active .el-submenu__icon-arrow {
    color: #2DF2FF !important;
  }

  .personal_center {
    background-color: #1287C9;
    margin-left: auto;
    margin-right: 1.6%;
  }  
  .el-dropdown-link {
    cursor: pointer;
  }
  .user-name {
    display: inline-block;
    padding: 0px 16px 0px 16px;
    height: 47px;
    line-height: 47px;
    color: #FFFFFF;
    cursor: pointer;
    font-size: 16px;
  }
  .user-name:hover {
    background-color: #0E6CA1;
  }
  .user-name .el-icon-arrow-left {
    color: #FFFFFF;
  }
 .el-icon-s-custom {
    margin-right: 6px;
    font-size: 20px;
    vertical-align: middle;
  }

  .p_c_dropdown_menu {
    min-width: 124px;
    background-color: #1287C9 !important;
    border: 1px solid #1287C9 !important;
  }
  .p_c_dropdown_menu .el-dropdown-menu__item {
    height: 40px !important;
    color: #FFFFFF;
    font-size: 16px;
  }
  .p_c_dropdown_menu .el-dropdown-menu__item:hover {
    background-color: #0E6CA1 !important;
    color: #FFFFFF !important;
  }
  .p_c_dropdown_menu .el-dropdown-menu__item:active {
    color: #2DF2FF !important;
  }
  .header{
    width: 100%;
    height: 160px;
    background: url("~@/assets/header-bg.png") no-repeat;
    background-size: cover;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .header .left-icon{
    margin-left: 76px;
    height: 64px;
  }
  .header .title{
    font-size: 54px;
    color: #0793EE;
    text-shadow:  -3px 0 #fff, 0 3px #fff, 3px 0 #fff, 0 -3px #fff;
    flex: 1;
    margin-left: 16px;
    margin-top: 40px;
  }
  .smallTitle{
    color:#FFFFFF;
    font-weight: bold;
    height:48px;
    line-height:48px;
    margin: 0 0 0 25px;
    font-size: 20px;
  }
  .header .right-icon-wrapper {
    height: 75%;
  }
  .header .right-icon{
    margin-right: 76px;
    height: 100%;
  }
  .login-footer{
    text-align:center
  }
  .footer{
    width: 100%;
    height: 40px;
    line-height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    bottom: 10px;
    position: fixed; 
    z-index:999;
    color: #0793EE;
    font-size: 14px;
  }
  .historyBack{
      margin: 0px;
      line-height: 48px;
      color: #fff;
      cursor: pointer;
      height: 48px;
  }
</style>
